import { useContext, useEffect, useState } from "react";
import { BasicDealerData, DealerData } from "../types";
import { UserLocationContext } from "../UserLocation/UserLocationContext";

const useDealerUrl = (dealer: DealerData | BasicDealerData) => {

    const {postalCode} = useContext(UserLocationContext);

    const [dealerUrl, setDealerUrl] = useState<string | null>(null);

    useEffect(() => {
      if(!dealer || !postalCode) return;

      let directionUrl = encodeURIComponent(dealer.address + ',' + dealer.city + ',' + dealer.province);
      let url = 'https://www.google.com/maps/dir/';
          url += postalCode ? postalCode.replace(" ", '+') : 'Current+Location';
          url += '/' + directionUrl;

      setDealerUrl(url);

    }, [dealer, postalCode]);

    return dealerUrl;
}

export default useDealerUrl;
